import {ContactCardLocationsEnum} from '../../../store/panels/contacts/contactCard/contactCardPanelState';

export function computeContactCardLocationTracking(location: ContactCardLocationsEnum) {
  return location === ContactCardLocationsEnum.MESSAGE_VIEWER ? 'p3' : 'calendar';
}
